export default __webpack_public_path__ + "static/media/electric.0afd21aa.svg";